<template>
  <v-dialog
    v-model="setDialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :max-width="modalConfirmacao ? '372' : '768'"
    persistent
  >
    <v-card data-cy="modal_desistir_reembolso">
      <template v-if="!modalConfirmacao">
        <v-card-title
          class="body-1 pt-4 pb-0 font-weight-bold grey--text text--darken-1"
          primary-title
          data-cy="modal_score_titulo"
        >
          Avaliar produto
        </v-card-title>

        <v-card-text
          class="pt-2 pb-9"
        >
          <h1
            :class="[$vuetify.breakpoint.smAndUp ? 'headline' : 'title']"
            class="primary--text text-center mt-lg-12 mt-6"
            data-cy="modal_score_nome_produto"
          >
            {{ tituloModal(produto.name) }}
          </h1>
          <div class="px-md-6 px-lg-12 mx-lg-5">
            <p
              class="mb-0 mt-2 px-lg-12 px-md-8 px-sm-6 px-xs-4 text-center"
              data-cy="modal_score_texto"
            >
              A avaliação do produto é anônima. O produtor não conseguirá identificar ou
              localizar informações sobre você.
            </p>
          </div>

          <div class="d-flex justify-center py-lg-8 py-md-6 py-4 pl-0">
            <ul class="d-flex smile ma-0 pl-0">
              <li class="smile__item">
                <p
                  aria-hidden="true"
                  class="mb-0"
                  :class="[$vuetify.breakpoint.smAndUp ? 'pt-1' : '']"
                >
                  Péssimo
                </p>
              </li>
              <li
                class="smile__item d-flex flex-column"
                :aria-label="produtoAvaliado
                  ? `Você avaliou o produto em ${avaliacaoAtual} de 5 em possíveis`
                  : 'Avalie seu produto de 1 a 5'"
              >
                <div
                  :class="[
                    containerBtn,
                    !produtoAvaliado || btnsClasseAtivo,
                  ]"
                  class="smile__group d-flex"
                >
                  <div
                    v-for="(value, name) in classesBtn"
                    :key="name"
                    :class="classesBtn[parseInt(name, 10)]"
                    class="smile__group-item"
                  >
                    <v-icon
                      v-if="!produtoAvaliado"
                      class="smile__btn -edit mx-lg-3 mx-1"
                      :aria-label="`Botão de avaliação do produto, ${name} de 5 possíveis`"
                      :large="$vuetify.breakpoint.smAndUp"
                      @click="iconeParents(parseInt(name, 10))"
                    >
                      fas fa-smile
                    </v-icon>
                    <v-icon
                      v-else
                      class="smile__btn -preview mx-lg-3 mx-1"
                      :large="$vuetify.breakpoint.smAndUp"
                    >
                      fas fa-smile
                    </v-icon>
                  </div>
                </div>
                <v-tooltip
                  v-model="erroTooltips"
                  bottom
                  color="error"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" />
                  </template>
                  <span>Selecione uma avaliação</span>
                </v-tooltip>
              </li>
              <li>
                <p
                  aria-hidden="true"
                  class="mb-0"
                  :class="[$vuetify.breakpoint.smAndUp ? 'pt-1' : '']"
                >
                  Ótimo
                </p>
              </li>
            </ul>
          </div>
          <h2
            :class="[$vuetify.breakpoint.smAndUp ? 'headline' : 'title']"
            class="primary--text text-center mt-4 mt-md-5 mt-lg-7"
            data-cy="modal_score_avaliacao"
          >
            O que motivou sua avaliação {{ produtoAvaliado ? ':' : '?' }}
          </h2>
          <v-chip-group
            v-if="!produtoAvaliado"
            active-class="primary"
            class="tags mt-md-8 mt-4"
            column
            multiple
          >
            <v-chip
              v-for="tag in tagsProduto"
              :key="tag.id"
              :data-cy="`modal_score_tag-${tag.id}`"
              :input-value="tag.marked"
              class="ml-2"
              @click="tagsClick(tag.id)"
            >
              {{ tag.name }}
            </v-chip>
          </v-chip-group>

          <div
            v-else
            class="d-flex justify-center flex-wrap mt-md-8 mt-4"
          >
            <v-chip
              v-for="tag in tagsProduto"
              :key="tag.id"
              :aria-label="!tag.marked || 'Avaliação selecionada'"
              :color="tag.marked ? 'primary' : ''"
              :data-cy="`modal_score_tag-${tag.id}`"
              class="mx-2 mt-2"
            >
              {{ tag.name }}
            </v-chip>
          </div>
        </v-card-text>
      </template>
      <template v-else>
        <v-row
          v-if="loadEnviandoAvaliacao"
          class="pt-12"
        >
          <v-col cols="10" offset="1">
            <v-progress-linear
              color="primary"
              height="5"
              indeterminate
            />
          </v-col>
        </v-row>

        <v-card-text
          v-else
          class="pt-12"
        >
          <p class="text-center pt-md-5 pt-1">
            <v-icon
              :color="salvoSucesso ? 'success' : 'error'"
              x-large
            >
              fa {{ salvoSucesso ? 'fa-check-circle' : 'fa-times-circle' }}
            </v-icon>
          </p>
          <p
            data-cy="modal_score_mesagem_sucesso"
            class="text-center headline pt-1"
            :class="salvoSucesso ? 'success--text' : 'error--text'"
          >
            {{ salvoSucesso ?
              'Avaliação enviada com sucesso!' : 'Erro ao enviar a avalição. Tente novamente' }}
          </p>
        </v-card-text>
      </template>

      <v-card-actions class="pt-9">
        <v-spacer />
        <template v-if="!modalConfirmacao">
          <v-btn
            color="primary"
            text
            data-cy="modal_score_cancelar"
            :absolute="$vuetify.breakpoint.xsOnly"
            :bottom="$vuetify.breakpoint.xsOnly"
            :right="$vuetify.breakpoint.xsOnly && produtoAvaliado"
            @click="setDialog = false"
          >
            {{ produtoAvaliado ? 'Fechar' : 'Cancelar' }}
          </v-btn>

          <v-btn
            v-if="!produtoAvaliado"
            color="primary"
            data-cy="modal_score_salvar"
            text
            :absolute="$vuetify.breakpoint.xsOnly"
            :bottom="$vuetify.breakpoint.xsOnly"
            :right="$vuetify.breakpoint.xsOnly"
            @click="salvarAvaliacao"
          >
            Salvar Avaliação
          </v-btn>
        </template>
        <template v-else>
          <v-btn
            color="primary"
            text
            data-cy="modal_score_fechar"
            :absolute="$vuetify.breakpoint.xsOnly"
            :bottom="$vuetify.breakpoint.xsOnly"
            :right="$vuetify.breakpoint.xsOnly"
            @click="fecharAvaliacao"
          >
            Fechar
          </v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'ScoreProduto',

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    produto: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      avaliacaoAtual: null,
      btnsClasseAtivo: 'smile__group-active',
      classesBtn: {
        1: '',
        2: '',
        3: '',
        4: '',
        5: '',
      },
      containerBtn: '',
      erroTooltips: false,
      loadEnviandoAvaliacao: false,
      modalConfirmacao: false,
      produtoAvaliado: false,
      salvoSucesso: true,
      tagsProduto: [],
      tagsId: [],
      valueScore: null,
    };
  },

  computed: {
    ...mapState(['dadosTransacao']),

    retornaProdutoAtual() {
      const { products: produtos } = this.dadosTransacao;
      if (!this.objetoValido(produtos)) return {};
      return produtos.find(elemento => elemento.id === this.produto.id);
    },

    setDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit('changeDialog', value);
      },
    },
  },

  created() {
    this.tags();
    this.avaliacaoProduto();
  },

  methods: {
    ...mapActions(['setDadosTransacao']),

    avaliacaoProduto() {
      if (this.objetoValido(this.retornaProdutoAtual.score)) {
        const { score: { value } } = this.retornaProdutoAtual;
        if (value) {
          this.avaliacaoAtual = value;
          this.classesBtn[value] = `smile__group-item-${value}`;
          this.produtoAvaliado = true;
        }
      }
    },

    async atualizarTransacao() {
      const url = `order/${this.dadosTransacao.id}`;

      await api
        .get(url)
        .then((response) => {
          this.setDadosTransacao(response.data);
          this.loadEnviandoAvaliacao = false;
        })
        .catch(() => {
          this.$router.go(this.$router.currentRoute);
        });
    },

    async enviaAvaliacao() {
      this.loadEnviandoAvaliacao = true;

      const send = {
        score: this.valueScore,
        tags: this.tagsId,
      };

      await api
        .post(`orders/${this.dadosTransacao.id}/${this.produto.id}/rating`, send)
        .then(() => {
          this.salvoSucesso = true;
          this.atualizarTransacao();
          this.scoreConsumidor(this.dadosTransacao.id);
        })
        .catch(() => {
          this.salvoSucesso = false;
          this.loadEnviandoAvaliacao = false;
        });
    },

    fecharAvaliacao() {
      this.setDialog = false;
    },

    iconeParents(indice) {
      let semClasse = true;
      this.containerBtn = '';
      this.erroTooltips = false;
      this.valueScore = null;

      if (this.classesBtn[indice] === '') {
        this.classesBtn[indice] = `smile__group-item-${indice}`;
        semClasse = false;
        this.valueScore = indice;
      }

      if (!semClasse) this.containerBtn = this.btnsClasseAtivo;

      Object.keys(this.classesBtn).forEach((key, index) => {
        if (semClasse || (index + 1) !== indice) this.classesBtn[key] = '';
      });
    },

    objetoValido(obj) {
      if (obj) return true;

      return false;
    },

    salvarAvaliacao() {
      if (!this.valueScore) {
        this.erroTooltips = true;
      } else {
        Object.keys(this.tagsProduto).forEach((key) => {
          if (this.tagsProduto[key].marked) {
            this.tagsId.push(this.tagsProduto[key].id);
          }
        });
        this.modalConfirmacao = true;
        this.enviaAvaliacao();
      }
    },

    async scoreConsumidor(orderId) {
      await api.post('/consumer_score', {
        action: 'score_product',
        orderId,
      });
    },

    tags() {
      if (this.objetoValido(this.retornaProdutoAtual.score)) {
        const { score: { tags } } = this.retornaProdutoAtual;
        this.tagsProduto = tags;
      }
    },

    tagsClick(id) {
      const foundIndex = this.tagsProduto.findIndex(tag => tag.id === id);
      this.tagsProduto[foundIndex].marked = this.produtoAvaliado
        ? this.tagsProduto[foundIndex].marked : !this.tagsProduto[foundIndex].marked;
    },

    tituloModal(produto) {
      if (this.produtoAvaliado) return `Como você avaliou ${produto}.`;
      return `Como você avalia ${produto}?`;
    },
  },
};
</script>

<style lang="scss">
.tags {
  .v-slide-group__content {
    justify-content: center;
  }
}
</style>

<style lang="scss" scope>
$cinza: #D3D4D3;
.smile {
  list-style: none;

  &__btn { color: $cinza !important; }

  &__group {
    &-active {
      .smile__group-item .smile__btn { color: var(--v-primary-base) !important; }
    }

    &:hover {
      .smile__group-item .smile__btn.-edit { color: var(--v-primary-base) !important; }
    }

    &-item {
      .smile__btn-active { color: var(--v-primary-base) !important; }
      &:hover {
        ~ .smile__group-item {
          .smile__btn.-edit { color: $cinza !important; }
        }
      }
    }

    @for $i from 1 through 5 {
      &-item-#{$i} {
        ~ .smile__group-item {
          .smile__btn { color: $cinza !important; }
        }
      }
    }
  }
}
</style>
